export default 0.3059112739103;
